<template>
  <v-list-tile @click="">
    <v-tooltip class="state_tooltip" left :key="`${info.invoice_id}_fax-state`">
      <div :class="['invoice_state', faxState(info)]" slot="activator"></div>
    </v-tooltip>
    <div class="customer_title">
      <p class="mb-0" style="font-weight: 450;font-size: 20px;text-align:center;white-space: pre;overflow: hidden;text-overflow: ellipsis;">{{ info.first_name }}</p>
      <p class="mb-0" style="font-size: 10px;text-align:center;">{{ info.title }}</p>
    </div>

    <v-list-tile-content @click="$router.push({name:'view', params: {invoice_id: info.invoice_id}})">
      <v-list-tile-title>{{ info.address }}</v-list-tile-title>
      <v-list-tile-sub-title>{{ info.primary_telephone }} / {{ info.second_telephone ? info.second_telephone : "N/A" }}</v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-list-tile-action-text>#{{ info.invoice_id }}</v-list-tile-action-text>
      <v-btn icon @click="$emit('mark')"><v-icon :color="info.marked ? 'yellow' : 'grey'">{{ info.marked ? 'star' : 'star_border' }}</v-icon></v-btn>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
export default {
  props: ['info'],
  name: 'simple-invoice-cell',
  data () {
    return {
    }
  },
  methods: {
    faxState(item) {
      const fax_state = {
        "A": 'not_faxed',
        "B": 'not_checked',
        "C": 'checked'
      }
      return fax_state[item.send_state]
    }
  }
}
</script>

<style scoped>
.customer_title {
  min-width: 50px;
  max-width: 50px;
  margin-right: 12px;
}
.state_tooltip {
  position: absolute;
  left: 0;
  width: 2px;
  height: 100%;
}
.invoice_state {
  width: 100%;
  height: 100%;
}
.invoice_state.not_faxed {
  background: #cc392e;
}
.invoice_state.not_checked {
  background: #f4af00;
}
.invoice_state.checked {
  background: #83c13a;
}
</style>



// WEBPACK FOOTER //
// src/components/SimpleInvoiceCell.vue